import { Box, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { getYouTubeId } from "../../utils/embed";
import { useYouTubeTitle } from "../../hooks/useYouTubeTitle";
import styles from "./styles";

const PlaylistRow = ({ url, index, isActive, onClick }) => {
  const ytId = getYouTubeId(url);
  const { data: title } = useYouTubeTitle(url);

  return (
    <Box onClick={onClick} sx={styles.rowSx(isActive)}>
      <Box sx={styles.accentBarSx(isActive)} />

      <Box sx={styles.rowIndexBoxSx}>
        {isActive ? (
          <PlayArrowIcon sx={styles.rowPlayIconSx} />
        ) : (
          <Typography sx={styles.rowIndexSx}>{index + 1}</Typography>
        )}
      </Box>

      <Box sx={styles.rowThumbBoxSx(isActive)}>
        <Box
          component="img"
          src={`https://img.youtube.com/vi/${ytId}/mqdefault.jpg`}
          alt={title || `Video ${index + 1}`}
          sx={styles.rowThumbImgSx(isActive)}
        />
        {!isActive && (
          <Box sx={styles.rowThumbOverlaySx}>
            <PlayArrowIcon sx={styles.rowThumbPlayIconSx} />
          </Box>
        )}
      </Box>

      <Typography sx={styles.rowTitleSx(isActive)}>{title || ""}</Typography>
    </Box>
  );
};

export default PlaylistRow;
